// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control.input-search{
	height:38px;
	border-radius:8px;
	margin-top:8px;
	margin-bottom:8px;
}
.input-search{
	height:38px;
	border-radius:8px;
	margin-top:8px;
	margin-bottom:8px;
	border:1px solid #eee;
	padding: 0 8px;
}


.filtering-table thead th:first-child{
	width:70px;
}
.table tfoot tr {
    border-bottom-width: 1px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    border-color: #EEEEEE;
}

.filter-pagination{
	display: inline-block;
    background: var(--primary);
    border-radius: 10px;
    padding: 5px 5px;
}
.filter-pagination .previous-button,
.filter-pagination .next-button{
    font-size: 16px;
    border: 0 !important;
    width: auto;
	padding: 14px 20px;
	margin: 0 5px;
    border-radius: 10px;
    display: inline-block;
    background-color: var(--bs-card-bg);
	color: #fff;
}
.filter-pagination button:hover{
	background:	var(--primary);
	color:#fff;
}
.filter-pagination button[disabled]{
	opacity:0.5;
	cursor: default;
}
.filter-pagination button[disabled]:hover{
	background:	var(--primary);
	opacity:0.5;
	color:#fff;
}
.table-index input[type=number] {
    background:var(--primary)!important;
    color: #fff;
    width: 70px;
    border: 0;
    background-color: #f8f8f8;
    padding: 6px 0 6px 10px;
}
@media only screen and (max-width: 575px) {

    .filter-pagination .previous-button,
    .filter-pagination .next-button{
        padding:8px 10px;
        font-size:14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/jsx/components/table/FilteringTable/filtering.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;AACf;;;AAGA;CACC,UAAU;AACX;AACA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;CACC,qBAAqB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;;IAEI,eAAe;IACf,oBAAoB;IACpB,WAAW;CACd,kBAAkB;CAClB,aAAa;IACV,mBAAmB;IACnB,qBAAqB;IACrB,mCAAmC;CACtC,WAAW;AACZ;AACA;CACC,0BAA0B;CAC1B,UAAU;AACX;AACA;CACC,WAAW;CACX,eAAe;AAChB;AACA;CACC,0BAA0B;CAC1B,WAAW;CACX,UAAU;AACX;AACA;IACI,mCAAmC;IACnC,WAAW;IACX,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;;IAEI;;QAEI,gBAAgB;QAChB,cAAc;IAClB;AACJ","sourcesContent":[".form-control.input-search{\n\theight:38px;\n\tborder-radius:8px;\n\tmargin-top:8px;\n\tmargin-bottom:8px;\n}\n.input-search{\n\theight:38px;\n\tborder-radius:8px;\n\tmargin-top:8px;\n\tmargin-bottom:8px;\n\tborder:1px solid #eee;\n\tpadding: 0 8px;\n}\n\n\n.filtering-table thead th:first-child{\n\twidth:70px;\n}\n.table tfoot tr {\n    border-bottom-width: 1px;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    border-color: #EEEEEE;\n}\n\n.filter-pagination{\n\tdisplay: inline-block;\n    background: var(--primary);\n    border-radius: 10px;\n    padding: 5px 5px;\n}\n.filter-pagination .previous-button,\n.filter-pagination .next-button{\n    font-size: 16px;\n    border: 0 !important;\n    width: auto;\n\tpadding: 14px 20px;\n\tmargin: 0 5px;\n    border-radius: 10px;\n    display: inline-block;\n    background-color: var(--bs-card-bg);\n\tcolor: #fff;\n}\n.filter-pagination button:hover{\n\tbackground:\tvar(--primary);\n\tcolor:#fff;\n}\n.filter-pagination button[disabled]{\n\topacity:0.5;\n\tcursor: default;\n}\n.filter-pagination button[disabled]:hover{\n\tbackground:\tvar(--primary);\n\topacity:0.5;\n\tcolor:#fff;\n}\n.table-index input[type=number] {\n    background:var(--primary)!important;\n    color: #fff;\n    width: 70px;\n    border: 0;\n    background-color: #f8f8f8;\n    padding: 6px 0 6px 10px;\n}\n@media only screen and (max-width: 575px) {\n\n    .filter-pagination .previous-button,\n    .filter-pagination .next-button{\n        padding:8px 10px;\n        font-size:14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
